module.exports = __webpack_public_path__ + "img/pr-30.be6786b6.png";